import { useTranslation } from 'react-i18next';
import React from 'react';
import { KPICard } from '../../../../../../../shared/components/card/KPICard';
import ExternalProfileBrandDetail from './ExternalProfileBrandDetail';
import { ICollaboration } from '../../../../../../../model/shared/ICollaboration';
import { FaCat, FaDiamond, FaDiamondTurnRight } from 'react-icons/fa6';
import { formatDate } from '../../../../../../../shared/functions/Functions';
import { Col, Row } from 'react-bootstrap';

interface ExternalProfileCollaborationsTabProps {
    collaborations: ICollaboration;
}
export function ExternalProfileCollaborationsTab({ collaborations }: ExternalProfileCollaborationsTabProps) {
    const { t } = useTranslation();
    const isBrand = collaborations?.isBrand;
    return (
        <>
            <h4>{t('brand.campaign.book.external_search.collaboration_summary')}</h4>
            <Row>
                {!isBrand && (
                    <Col lg={2} xs={4}>
                        <KPICard
                            value={collaborations?.totalDistinctBrands ?? 0}
                            text={t('brand.campaign.book.external_search.brands')}
                            img={'/icons/kpi/img-brands.svg'}
                        />
                    </Col>
                )}
                {isBrand && (
                    <Col lg={2} xs={4}>
                        <KPICard
                            value={collaborations?.totalDistinctBrands ?? 0}
                            text={t('brand.campaign.book.external_search.influencers')}
                            img={'/icons/kpi/img-influencers.svg'}
                        />
                    </Col>
                )}
                <Col lg={2} xs={4}>
                    <KPICard
                        value={collaborations?.totalCollaboration ?? 0}
                        text={t('brand.campaign.book.external_search.collaborations')}
                        img={'/icons/kpi/img-collaborations.svg'}
                    />
                </Col>
                <Col lg={2} xs={4}>
                    <KPICard
                        value={collaborations?.totalDistinctPosts ?? 0}
                        text={t('brand.campaign.book.external_search.posts')}
                        img={'/icons/kpi/img-posts.svg'}
                    />
                </Col>
                <Col className="mt-lg-0 mt-3" lg={2} xs={4}>
                    <KPICard
                        value={formatDate(collaborations?.firstCollaborationDate)}
                        text={t('brand.campaign.book.external_search.first_collaboration')}
                        img={'/icons/kpi/img-first-collab.svg'}
                    />
                </Col>
                <Col className="mt-lg-0 mt-3" lg={2} xs={4}>
                    <KPICard
                        value={formatDate(collaborations?.lastCollaborationDate)}
                        text={t('brand.campaign.book.external_search.last_collaboration')}
                        img={'/icons/kpi/img-last-collab.svg'}
                    />
                </Col>
            </Row>
            <h4 className="mt-4">
                {isBrand
                    ? t('brand.campaign.book.external_search.influencer_summary')
                    : t('brand.campaign.book.external_search.brand_summary')}
            </h4>
            <p className="text-muted">
                {isBrand
                    ? t('brand.campaign.book.external_search.influencer_summary_desc')
                    : t('brand.campaign.book.external_search.brand_summary_desc')}
            </p>
            {collaborations?.brandCollaborations?.map(brand => (
                <ExternalProfileBrandDetail key={brand?.id} brand={brand} isInfluencer={isBrand} />
            ))}
        </>
    );
}
